// src/components/PDFPreviewModal.js

import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { X, ZoomIn, ZoomOut, Printer, Download, PlusSquare } from 'lucide-react'; 

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './PDFPreviewModal.css';

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

export default function PDFPreviewModal({ pdfData, pdfBlob, isOpen, onClose, includeBlankPage, onToggleBlankPage }) {
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1.5); // Começa um pouco maior para ver melhor na tela

  if (!isOpen || !pdfData) return null;

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  const handleZoomIn = () => setScale(prevScale => Math.min(prevScale + 0.1, 2.5));
  const handleZoomOut = () => setScale(prevScale => Math.max(prevScale - 0.1, 0.5));

  // --- NOVA FUNÇÃO DE IMPRESSÃO (A PROVA DE BALAS) ---
  const handlePrint = () => {
    if (!pdfBlob) return;

    const url = URL.createObjectURL(pdfBlob);
    const iframe = document.createElement('iframe');
    
    // O Chrome ignora iframes com "display: none" na hora de imprimir. 
    // Usamos tamanho 0 e position absolute.
    iframe.style.position = 'absolute';
    iframe.style.width = '0px';
    iframe.style.height = '0px';
    iframe.style.border = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (e) {
        console.error("Erro ao imprimir:", e);
        alert("Seu navegador bloqueou a janela de impressão. Use o botão de Download.");
      }
      
      // A MÁGICA AQUI: Esperamos 2 MINUTOS (120000ms) antes de apagar o iframe.
      // Isso dá tempo de sobra para o usuário escolher a impressora e clicar em 'Imprimir'.
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
        URL.revokeObjectURL(url);
      }, 120000); 
    };
  };

  const handleExport = () => {
    if (!pdfBlob) return;
    const url = URL.createObjectURL(pdfBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `folha-visita-${new Date().toLocaleDateString('pt-BR').replace(/\//g, '-')}.pdf`;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
  };

  return (
    <div className="pdf-modal-overlay" onClick={onClose}>
      <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
        
        <header className="pdf-modal-header">
          <h3>Visualização A4</h3>
          <div className="pdf-modal-controls">
            
            {/* O BOTÃO DA PÁGINA EM BRANCO */}
            <button 
                className={`blank-page-toggle ${includeBlankPage ? 'active' : ''}`}
                onClick={() => onToggleBlankPage(!includeBlankPage)}
                title="Adiciona uma página extra no final apenas com o cabeçalho"
            >
                <PlusSquare size={16} /> 
                {includeBlankPage ? 'Página Extra Adicionada' : '+1 Página em Branco'}
            </button>

            <span className="separator">|</span>

            <button onClick={handleExport} className="action-btn pdf-modal-export-btn">
              <Download size={15} /> Baixar PDF
            </button>
            <button onClick={handlePrint} className="action-btn pdf-modal-print-btn">
              <Printer size={15} /> Imprimir
            </button>
            
            <span className="separator">|</span>

            <div className="pdf-modal-zoom-controls">
              <button onClick={handleZoomOut} disabled={scale <= 0.5}><ZoomOut size={16} /></button>
              <span>{Math.round(scale * 100)}%</span>
              <button onClick={handleZoomIn} disabled={scale >= 2.5}><ZoomIn size={16} /></button>
            </div>
          </div>
          <button className="pdf-modal-close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </header>

        <div className="pdf-document-container">
          <Document file={pdfData} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages || 0), (el, index) => (
              <Page 
                key={`page_${index + 1}`} 
                pageNumber={index + 1} 
                scale={scale} 
                renderTextLayer={false}
              />
            ))}
          </Document>
        </div>
      </div>
    </div>
  );
}